module.exports = __webpack_public_path__ + "img/shape_hearth--yellow.deddb72.png";